export default function resolveChoices (routes, choiceObj) {
  if (typeof choiceObj === 'string') {
    // named choice
    return resolveChoices(routes, routes.choices[choiceObj]);
  }
  if (Array.isArray(choiceObj)) {
    // literal choice - it's resolved
    return choiceObj;
  }
  // other - not resolvable at runtime for now
  return false;
}



// WEBPACK FOOTER //
// ./lib/rlink-router/resolveChoices.js